import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Task, TaskTypeAction } from '@k12/models';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'lib-task-header-info',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './task-header-info.component.html',
  styleUrls: ['./task-header-info.component.scss']
})
export class TaskHeaderInfoComponent {
  @Input() task: Task | null | undefined = null;
  @Input() taskTypeAction: TaskTypeAction | null | undefined = null;
  @Input() recentTaskNote: string = '';
  @Input() headerClass: string = 'task-header-info';
}
